import styled from 'styled-components/macro';

export const BookingMaskWrapper = styled.div`
  width: 100%;
  .boxSearch {
    border: 1px solid #e5e5e5;
    border-radius: 10px;
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .comboHolidaySection {
    flex-direction: column;
    align-items: stretch;
    height: auto;
    min-height: 50px;
    padding: 14px 14px 12px;
    gap: 10px;
  }
  .comboTypeBar {
    width: 60%;
    box-sizing: border-box;

    .ant-row {
      display: flex;
      flex-wrap: wrap;
      row-gap: 8px;
      column-gap: 12px;
      margin: 0 !important;
    }

    .ant-col {
      flex: 0 1 auto;
      max-width: 100%;
      padding: 0 !important;
    }
  }
  .hotelDateRange {
    flex: 1;
    padding-right: 14px;
  }
  .hotelDateRangeInput {
    flex: 1;
    min-width: 0;
  }
  .nightsBadge {
    font-size: 12px;
    color: #444;
    white-space: nowrap;
    padding: 4px 10px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fafafa;
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 8px;
  }
  .hotelRoomSection {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 10px;
    padding-left: 10px;
    flex-shrink: 0;
  }
  .boxRadio {
    display: flex;
    flex: 1;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    height: 38px;
    border-radius: 8px;
    gap: 10px;
    font-size: 14px;
  }
  .boxRadio[data-active='true'] {
    background: #d4d4d4;
  }
  .boxPoint {
    display: flex;
    flex: 1;
    gap: 10px;
    align-items: center;
    padding-right: 14px;
    cursor: pointer;
  }
  .boxColumnDivider {
    width: 1px;
    height: 100%;
    background-color: #e5e5e5;
    position: relative;
  }
  .boxTrailing {
    position: absolute;
    border: 1px solid #e5e5e5;
    border-radius: 25px;
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    left: -12.5px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
  }
  .boxDate {
    display: flex;
    flex: 1;
    gap: 10px;
    align-items: center;
    padding-right: 14px;
  }
  .dataPicker {
    width: 100%;
    background-color: transparent;
    border: none !important;
    padding: 0 !important;
    box-shadow: none !important;
    .ant-picker-input > input {
      ::placeholder {
        font-style: normal;
        color: #999;
        opacity: 1;
      }
    }
  }
  .sub-title {
    font-size: 13px;
    font-weight: 600;
    color: #000;
  }
  .note-title {
    font-size: 11px;
    color: #444444;
  }
  .form-inputNumber {
    background: #f2f2f2;
    width: 100px;
    height: 35px;
    display: flex;
    align-items: center;
    .ant-input-number-input {
      font-size: 14px;
      background: #f2f2f2;
    }
    .ant-input-number-group-addon {
      line-height: 22px;
      background: #f2f2f2;
      i {
        background: #f2f2f2 !important;
      }
    }
    .ant-input-number {
      max-width: 70px;
    }
  }
  .contentPopover {
    display: flex;
    flex: 1;
    margin: -10px;
    height: 400px;
    overflow-y: hidden;
  }
  .contentPopoverLeft {
    flex: 1;
    border-right: 2px solid #e5e5e5;
    background: #f2f2f2;
    overflow-y: auto;
  }
  .boxRegion {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    cursor: pointer;
    .active {
      background-color: #e5e5e5;
    }
    &:hover {
      background-color: #e5e5e5;
    }
  }
  .boxRegion[data-active='true'] {
    background: #e5e5e5;
  }
  .contentPopoverRight {
    flex: 3;
    background-color: '#fff';
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .boxAirport {
    padding-top: 9px;
    padding-bottom: 9px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    cursor: pointer;
    &:hover {
      background-color: #e5e5e5;
    }
  }
  .boxAirport[data-active='true'] {
    background: #e5e5e5;
  }
`;
